import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Table from '..'
import classNames from 'classnames'

const Collapsible = ({ styles: customizedStyles, columns, data, subColumns, subDataAccessor, ...restProps }) => {
  const styles = _.defaultsDeep({}, customizedStyles, defaultStyles)
  restProps.className = classNames('-highlight', restProps.className)
  restProps.collapseOnDataChange = false
  return (
    <Table columns={columns} data={data} styles={styles.mainTable} {...restProps} SubComponent={(row) => (
      <Table columns={subColumns.map((subColumn) => ({ ...subColumn, subComponentIndex: row.index }))}
        data={row.original[subDataAccessor]}
        styles={styles.subTable}/>
    )}/>
  )
}

Collapsible.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array
}

export default Collapsible

const defaultStyles = {
  mainTable: {
    table: {
      maxHeight: '100%'
    },
    theadTr: {
      height: '28px'
    },
    theadTh: {
      padding: '.5rem'
    },
    tfootTd: {
      padding: '.5rem'
    },
    tbody: {
      display: 'block'
    },
    tr: {
      padding: 'none',
      cursor: 'pointer',
      height: '33px'
    },
    trGroup: {
      minHeight: 'none'
    },
    td: {
      padding: '.5rem',
      verticalAlign: 'middle',
      fontWeight: 'bold',
      textTransform: 'capitalize'
    }
  },
  subTable: {
    thead: {
      display: 'none'
    },
    tr: {
      padding: 'none',
      paddingLeft: '35px'
    },
    td: {
      padding: '.5rem'
    },
    trGroup: {
      minHeight: 'none',
      borderTop: '1px solid #f0f0f0',
      borderBottom: 'none'
    }
  }
}
